import api from "./Api";

class TransportadoraService {
  GetTransportadora(payload) {
    return api.get("/v1/transportadora/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTransportadora(payload) {
    return api.post("/v1/transportadora/", payload).then((response) => {
      return response.data;
    });
  }

  PutTransportadora(payload) {
    return api.put("/v1/transportadora/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTransportadora(payload) {
    return api.delete("/v1/transportadora/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTransportadoraOData(payload) {
    return api.get("/OData/Transportadora" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new TransportadoraService();
